module.exports = __webpack_public_path__ + "img/net-recomment.2d2902cd.svg";